module.exports = __webpack_public_path__ + "img/illegal-demolished.fe2ac792.png";